import * as React from 'react';

import {getMultipleEntityType} from 'nutshell-core/utils/get-multiple-entity-type';

import {Checkbox} from '../checkbox/checkbox';
import {EmptyStateSmall} from '../empty-states/empty-state-small';
import {Illustration} from '../illustrations/illustration';

import {getFieldKey, getTitle} from './helpers';
import type {EntityFormType, SelectableField} from './types';

import styles from './field-checkboxes.module.css';

type Props = {
    fields: any[];
    fieldList: SelectableField[];
    onChange: (fieldKey: string) => void;
    entityType: EntityFormType;
    isLeadCard?: boolean;
};

export function FieldCheckboxes(props: Props) {
    if (props.fields.length === 0) {
        return (
            <div className='flex align-center justify-center border-box full-width'>
                <EmptyStateSmall
                    title={`You don’t have any custom fields for ${getMultipleEntityType(
                        props.entityType
                    )}`}
                    subtitle='Once added, you can display or hide them from here'
                    icon={
                        <div style={{width: 80}}>
                            <Illustration src='cactus-empty-state' width='100%' height='100%' />
                        </div>
                    }
                />
            </div>
        );
    }

    return (
        <div className={styles.list}>
            {props.fields.map((field): any => {
                const selectedField = props.fieldList.find((f) => f.fieldId === getFieldKey(field));
                const isChecked = Boolean(selectedField);

                return (
                    <div
                        key={field.name}
                        title={field.isCustomField === true ? field.description : undefined}
                    >
                        <Checkbox
                            label={
                                <div className='flex'>
                                    {getTitle(
                                        field.name,
                                        field.title,
                                        props.entityType,
                                        props.isLeadCard
                                    )}
                                    {selectedField && selectedField.isRequired ? (
                                        <span className={styles.required}>*</span>
                                    ) : undefined}
                                </div>
                            }
                            checked={isChecked}
                            disabled={selectedField && selectedField.isRemoveable === false}
                            onChange={() => props.onChange(getFieldKey(field))}
                        />
                    </div>
                );
            })}
        </div>
    );
}
